import "./index.css";

export const Devoluciones = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Devoluciones</h1>
      </div>
    </div>
  );
};
